import SearchSalesMenuContainer from './SearchSalesMenuContainer';
export default SearchSalesMenuContainer;
